import { useEffect } from "react";

export default function SEO({ title, description, canonical, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }
    let link = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }
    document.querySelectorAll("script[data-page-jsonld]").forEach((s) => s.remove());
    (jsonLd || []).forEach((obj) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-page-jsonld", "true");
      script.textContent = JSON.stringify(obj);
      document.head.appendChild(script);
    });
  }, [title, description, canonical, jsonLd]);
  return null;
}

export const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Complisure Counsultancy",
  url: "https://compliance-capital-1.preview.emergentagent.com",
  telephone: "+91-73510-10107",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Level 8, Cyber Towers, HITEC City",
    addressLocality: "Hyderabad",
    addressRegion: "Telangana",
    postalCode: "500081",
    addressCountry: "IN",
  },
};

export const breadcrumbJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `https://compliance-capital-1.preview.emergentagent.com${it.path}`,
  })),
});
